<template>
  <div class="pages" :style="{ height: height + 'px' }">
    <navTop></navTop>
    <!-- 标题 -->
    <div class="title">
      <span>{{ obj.title }}</span>
    </div>
    <div class="box">
      <!-- 顶部 -->
      <div class="box-top">
        <div class="left" v-if="obj.serveType == 0">
          Type：Pre-loading / Discharging Survey
        </div>
        <div class="left" v-if="obj.serveType == 1">
          Type：On/Off Hire Bunker Survey/Bunker & Condition Survey
        </div>
        <div class="left" v-if="obj.serveType == 2">Type：Bunkering Survey</div>
        <div class="left" v-if="obj.serveType == 3">Type：Draft Survey</div>
        <div class="left" v-if="obj.serveType == 4">
          Type：Insurance Adjust Survey
        </div>
        <div class="right">Need to pay：${{ obj.sum }}</div>
      </div>
      <!-- 支付logo -->
      <div class="box-img">
        <img src="https://i02piccdn.sogoucdn.com/ad639c427d831c51" />
      </div>
      <div class="box-btn" @click="goSuccess">Immediate payment</div>
    </div>
    <div class="kefu">
      <img src="../../assets/kefu1.png" @click="isKefu = true" />
    </div>
    <kefu v-if="isKefu" style="margin-top: 130px"></kefu>
  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import kefu from "../../components/kefu.vue";
export default {
  name: "pay",
  components: {
    navTop,
    kefu,
  },
  data () {
    return {
      height: "", //页面高度
      isKefu: false, //客服状态
      obj: {},
    };
  },
  created () {
    if (!sessionStorage.getItem("uid")) {
      this.$router.push({ path: "/" });
    } else {
      this.height = window.innerHeight;
      this.obj = this.$route.query;
      console.log(this.obj);
    }
  },
  methods: {
    // 支付成功
    goSuccess() {
      if (this.obj.num == 0) {
        let data = {
          id: this.obj.id,
          type: 1,
          money: this.obj.sum
        };
        this.$api.createOrder(data).then((res) => {
          console.log(res);
          if (res.result == 0) {
            res.data.links.forEach((item) => {
              if (item.rel == 'approve') {
                // window.open(item.href);
                this.$router.push({ path: '/order' });
              }
            });
          }
        });
      } else {
        let data = {
          id: this.obj.id,
          type: 0,
          money: this.obj.sum
        };
        this.$api.createOrder(data).then((res) => {
          console.log(res);
          if (res.result == 0) {
            res.data.links.forEach((item) => {
              if (item.rel == 'approve') {
                // window.open(item.href);
                this.$router.push({ path: '/order' });
              }
            });
          }
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.pages {
  background: #000;
  position: relative;
  .box {
    //顶部
    .box-top {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 198px 0 181px;
      box-sizing: border-box;
      .left {
        padding: 0 20px;
        box-sizing: border-box;
        height: 40px;
        border: 1px solid #00fcff;
        font-size: 23px;
        color: #00fcff;
        line-height: 40px;
        text-align: center;
      }
      .right {
        padding: 0 20px;
        box-sizing: border-box;
        height: 40px;
        border: 1px solid #00fcff;
        font-size: 23px;
        color: #00fcff;
        line-height: 40px;
        text-align: center;
      }
    }
    // 支付logo
    .box-img {
      margin-top: 91px;
      padding-left: 181px;
      box-sizing: border-box;
      img {
        width: 120px;
        height: 90px;
        display: block;
      }
    }
    .box-btn {
      width: 728px;
      height: 104px;
      background: linear-gradient(
        90deg,
        rgba(29, 175, 170, 0.8) 0%,
        rgba(35, 254, 246, 0.8) 100%
      );
      font-size: 36px;
      font-weight: bold;
      color: #f6f6f6;
      line-height: 104px;
      text-align: center;
      margin: 143px auto 0;
    }
  }
  .title {
    width: 100%;
    height: 131px;
    background-image: url(../../assets/details-title.png);
    background-size: 100% 100%;
    margin-top: 50px;
    span {
      width: 100%;
      height: 87px;
      display: block;
      text-align: center;
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #00fcff;
      line-height: 87px;
      padding-right: 70px;
      box-sizing: border-box;
    }
  }
  .kefu {
    position: absolute;
    top: 742px;
    right: 115px;
    width: 130px;
    height: 130px;
    img {
      width: 130px;
      height: 130px;
      display: block;
    }
  }
}
</style>
